import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { environment } from '@environments/environment';

import { CreateDirOrFile } from '@classes/wiki/create-dir-or-file.model';
import { DirectoryModel } from '@classes/wiki/directory-model.model';

@Injectable({
  providedIn: 'root'
})
export class FileOrDirService {

  private event = new Subject<DirectoryModel>();
  private matTree = new Subject<DirectoryModel>();

  constructor(private httpClient: HttpClient) { }

  createFileOrDir(fileOrDir: CreateDirOrFile, provider: string = null): Observable<DirectoryModel> {
    return this.httpClient.post<DirectoryModel>(`${environment.apiUrl}wiki/files${provider === null ? '' : `?provider=${provider}`}`, fileOrDir);
  }

  getEvent(): Observable<DirectoryModel> {
    return this.event.asObservable();
  }

  emitEvent(dm: DirectoryModel): void {
    this.event.next(dm);
  }

  changeMatTree(dm: DirectoryModel): void {
    this.matTree.next(dm);
  }

  getMatTree(): Observable<DirectoryModel> {
    return this.matTree.asObservable();
  }
}
